import { Button, Icon } from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../../../state/state';
import { isAddFamilyMembersAllowed } from '../../../state/helpers';
import { Pages } from '../../../utils/constants';
import { useHistory } from 'react-router-dom';
import { hasPITOrPendingChange } from '../../../utils/ruleHelper';
import { PITWarningModal } from '../../PITWarningModal/PITWarningModal';
import { useState } from 'react';

export const AddMemberCTA = () => {
  const history = useHistory();
  const [membershipDetails] = useGlobalState('memberDetails');
  const [showPITWarningModal, setShowPITWarningModal] = useState(false);
  const addFamilyMembersAllowed = isAddFamilyMembersAllowed(membershipDetails);
  const hasPITPendingChange = hasPITOrPendingChange(membershipDetails);

  const onClick = () => {
    if (hasPITPendingChange) {
      setShowPITWarningModal(true);
    } else {
      history.push(Pages.RoleTypeSelection);
    }
  };

  return (
    <>
      <div className="add-member-cta-container" hidden={!addFamilyMembersAllowed}>
        <Button
          variant="tile"
          label="Add family members"
          startIcon={<Icon iconName="user-plus-duotone" />}
          id="AddMemberCTA"
          onClick={onClick}
          sx={{ background: 'white', whiteSpace: 'nowrap' }}
        />
      </div>
      <PITWarningModal
        visible={showPITWarningModal}
        onClose={() => {
          setShowPITWarningModal(false);
        }}
      />
    </>
  );
};
